import { useCallback } from "react";
import { API } from "../api";
import { useQueryParamSession } from "./useQueryParamSession";
import { UTMData } from "../types";

const sourceKey = "a";
const mediumKey = "b";
const campaignKey = "c";
const termKey = "d";
const contentKey = "e";

const useUTM = () => {
  const acquire = useCallback(async (utmData: UTMData) => {
    const res = await API.acquireUTMSessionToken(utmData);
    return res.data.data.sid;
  }, []);

  useQueryParamSession({
    keys: [sourceKey, campaignKey, mediumKey, termKey, contentKey],
    requiredKeys: [sourceKey, mediumKey],
    acquire,
    associate: API.associateUTMSessionToken,
    lsKey: "utm",
  });
};

export default useUTM;
